import { render, staticRenderFns } from "./CallUserForm.vue?vue&type=template&id=4edc8b7a&"
import script from "./CallUserForm.vue?vue&type=script&lang=js&"
export * from "./CallUserForm.vue?vue&type=script&lang=js&"
import style0 from "./CallUserForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports